export const SECTION_SKILLS_ID = 'section-skills';
